import React, { createContext, useContext, useReducer } from 'react';

// Action types
export const APP_ACTIONS = {
  SET_BRAND: 'SET_BRAND',
  SET_OHUHU_MODE: 'SET_OHUHU_MODE',
  RESET_STATE: 'RESET_STATE'
};

// Initial state - simplified without page navigation (handled by React Router)
const initialState = {
  brand: 'All',
  ohuhuMode: 'both', // old | new | both
};

// Reducer
function appReducer(state, action) {
  switch (action.type) {
    case APP_ACTIONS.SET_BRAND:
      return {
        ...state,
        brand: action.payload
      };
    case APP_ACTIONS.SET_OHUHU_MODE:
      return {
        ...state,
        ohuhuMode: action.payload
      };
    case APP_ACTIONS.RESET_STATE:
      return initialState;
    default:
      return state;
  }
}

// Context
const AppContext = createContext();

// Provider component
export function AppProvider({ children }) {
  const [state, dispatch] = useReducer(appReducer, initialState);

  const setBrand = (brand) => {
    dispatch({ type: APP_ACTIONS.SET_BRAND, payload: brand });
  };

  const setOhuhuMode = (mode) => {
    dispatch({ type: APP_ACTIONS.SET_OHUHU_MODE, payload: mode });
  };

  const resetState = () => {
    dispatch({ type: APP_ACTIONS.RESET_STATE });
  };

  const value = {
    // State
    ...state,
    // Actions
    setBrand,
    setOhuhuMode,
    resetState,
  };

  return (
    <AppContext.Provider value={value}>
      {children}
    </AppContext.Provider>
  );
}

// Hook to use the context
export function useAppContext() {
  const context = useContext(AppContext);
  if (!context) {
    throw new Error('useAppContext must be used within AppProvider');
  }
  return context;
}

export default AppContext;
